import { Expose } from 'class-transformer'
import { IsDefined, IsNumber, IsString } from 'class-validator'

export class Message {
    
    @Expose()
    @IsDefined()
    @IsNumber()
    id!: number

    @Expose()
    @IsDefined()
    @IsString()
    email!: string

    @Expose()
    @IsDefined()
    @IsString()
    name!: string

    @Expose()
    @IsDefined()
    @IsString()
    message!: string

    @Expose()
    @IsDefined()
    @IsString()
    phone!: string
}
